module.exports = __webpack_public_path__ + "static/media/image5.aa5a1aa7.jpg";